import axios from 'axios';

import {Contact} from '../util/actionTypes';
import {addNotification} from './notification';

export const formSubmit = (data) => (dispatch) => {
	dispatch({
		type: Contact.FormSubmit.REQUEST
	});

	axios.post(`${process.env.REACT_APP_API_URL}/open/contact`, data)
		.then((payload) => {
			if (payload.success) {
				dispatch({
					type: Contact.FormSubmit.SUCCESS
				});
			} else {
				dispatch({
					type: Contact.FormSubmit.FAILURE
				});

				dispatch(addNotification('error', 'Błąd podczas wysyłania', 'Upewnij się, że zostały wprowadzone poprawne dane i ponów próbę.'));
			}
		})
		.catch(() => {
			dispatch({
				type: Contact.FormSubmit.FAILURE
			});

			dispatch(addNotification('error', 'Błąd podczas wysyłania', 'Upewnij się, że zostały wprowadzone poprawne dane i ponów próbę.'));
		});
};
